import { createContext } from 'react';
import { IBusinessCustomVariablesValues } from 'app/interfaces/customVariablesInterfaces';
import { RelationPerson } from 'modules/customer/interfaces/businessRelation';
import { TRegisterBusinessDataRequest } from 'modules/customer/context';

export type StepItem = {
  step: number;
  title: string;
  subtitle?: string;
  handleClick?: () => void;
  clickable?: boolean;
  element?: JSX.Element;
};

type ILegalPersonHandlerStepperContext = {
  activeStep: number;
  onForward: () => void;
  onBack: () => void;
  onBackTwoSteps: () => void;
  hasCustomVariables?: boolean;
  updateHasCustomVariables: (hasCustomVariables: boolean) => void;
  createdBusiness: TRegisterBusinessDataRequest | null;
  handleCreatedBusiness: (
    business: TRegisterBusinessDataRequest | null,
  ) => void;
  customVariables: IBusinessCustomVariablesValues[] | null;
  updateCustomVariables: (variables: IBusinessCustomVariablesValues[]) => void;
  selectedRelationPersonList: RelationPerson[] | undefined;
  updatePersonList: (addedPerson?: RelationPerson) => void;
  removePersonFromList: (addedPerson?: RelationPerson) => void;
  handleSelectedRelationPersonListOrder: () => void;
  funding: string | null;
  hasMultiplesFundings: boolean;
  updateFunding: (funding: string) => void;
  utilizeCurrentAddressAsBilling: boolean;
  updateUtilizeCurrentAddressAsBilling: (utilize: boolean) => void;
  originator: string | null;
  updateOriginator: (originator: string | null) => void;
};

export const LegalPersonHandlerStepperContext =
  createContext<ILegalPersonHandlerStepperContext>({
    activeStep: 1,
    createdBusiness: null,
    hasCustomVariables: false,
    updateHasCustomVariables: () => {
      throw new Error('Método não implementado');
    },
    customVariables: null,
    selectedRelationPersonList: undefined,
    updateCustomVariables: () => {
      throw new Error('Método não implementado');
    },
    onForward: () => {
      throw new Error('Método não implementado');
    },
    onBack: () => {
      throw new Error('Método não implementado');
    },
    onBackTwoSteps: () => {
      throw new Error('Método não implementado');
    },
    handleCreatedBusiness: () => {
      throw new Error('Método não implementado');
    },
    updatePersonList: () => {
      throw new Error('Método não implementado');
    },
    removePersonFromList: () => {
      throw new Error('Método não implementado');
    },
    handleSelectedRelationPersonListOrder: () => {
      throw new Error('Método não implementado');
    },
    funding: null,
    hasMultiplesFundings: false,
    updateFunding: () => {
      throw new Error('Método não implementado');
    },
    utilizeCurrentAddressAsBilling: false,
    updateUtilizeCurrentAddressAsBilling: () => {
      throw new Error('Método não implementado');
    },
    originator: null,
    updateOriginator: () => {
      throw new Error('Método não implementado');
    },
  });
